<template>
	<div class="container editor-content-view">
		<div v-html="detailmodel.introduce">
			
		</div>
		<!-- <h3>【赛事背景】</h3>
		<div>
			人工智能的发展日新月异，也深刻的影响到人机交互领域的发展。手势动作作为一种自然、快捷的交互方式，在智能驾云资源领取 驶，虚拟现实等领域有着广泛的应用。手势识别的任务是，当操作者做出某个手势动作后，计算机能够快速准确的判断出该我的团队手势的类型。本赛题定位于基于视觉的动态手势识别任务，希望选手基于华为全栈AI技术，开发出精准高效的识别算法，助力人机交互技术的进步。提交作品 大赛坚持公平、公正、公开的原则广泛吸引全球人工智能的爱好者、企事业单位研究人员、高校与研究机构在校学生、老师等组队参与比赛，吸引优秀人才助力华为全栈AI研究。
		</div>
		<h3>【参与对象】</h3>
		<div>
			全国大/中/小学生。
		</div>
		<h3>【组队要求】</h3>
		<div>
			人工智能的展。手势动作作为一种自然、快捷的交互方式，在智能驾云资源领取 驶，虚拟现实等领域有着广泛的应用。手势识别的任务是，当操作者做出某个手势动作后，计算机能够快速准确的判断出该我的团队手势的类型。本赛题定位于基于视觉的动态手势识别任务，希望选手基于华为全栈AI技术，开 大赛坚持公平、公正、公开的原则广泛吸引全球人工智能的爱好者、企事业单位研究人员、高校与研究机构在校学生、老师等组队参与比赛，吸引优秀人才助力华为全栈AI研究。
		</div>
		<h3>【赛事规则】</h3>
		<div>
			人工智能的发一种自然、快捷的交互方式，在智
		</div> -->
	</div>
</template>

<script>
	import '@/assets/css/rich.less'

	import competitionModules from '@/modules/competition.js'
	export default {
		name: 'competitionInfo',
		components: {
			
		},
		mixins: [
			competitionModules
		],
		data(){
			return {
				
			}
		},
		methods: {
			
		}
	}
</script>

<style lang="less" scoped>
	.container{
		line-height: 22px;
		h3{
			font-weight: bold;
			line-height: 30px;
		}
	}
</style>
